module.exports = __webpack_public_path__ + "img/Operations.5b67cde5.svg";